import { useRef } from 'react';

interface ColorPickerFieldProps {
  label: string;
  value: string;
  onChange: (hex: string) => void;
  onExplicitSet?: () => void;
  placeholder?: string;
}

export default function ColorPickerField({ label, value, onChange, onExplicitSet, placeholder }: ColorPickerFieldProps) {
  const pickerRef = useRef<HTMLInputElement>(null);

  const handleColorChange = (hex: string) => {
    onChange(hex);
    onExplicitSet?.();
  };

  return (
    <div>
      <label className="block font-mono text-[10px] uppercase tracking-widest mb-1.5" style={{ color: 'var(--dash-text-dim)' }}>{label}</label>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => pickerRef.current?.click()}
          className="w-9 h-9 rounded flex-shrink-0 cursor-pointer"
          style={{ background: value || '#000000', border: '1px solid var(--dash-border)' }}
        />
        <input
          ref={pickerRef}
          type="color"
          value={value || '#000000'}
          onChange={(e) => handleColorChange(e.target.value)}
          className="sr-only"
        />
        <input
          type="text"
          value={value || ''}
          onChange={(e) => {
            const v = e.target.value;
            onChange(v);
            if (/^#[0-9a-fA-F]{6}$/.test(v)) {
              onExplicitSet?.();
            }
          }}
          placeholder={placeholder || '#000000'}
          className="w-full rounded px-3 py-2 font-sans text-sm focus:outline-none transition-colors"
          style={{
            border: '1px solid var(--dash-border)',
            background: 'var(--dash-input)',
            color: 'var(--dash-text-secondary)',
          }}
          maxLength={7}
        />
      </div>
    </div>
  );
}
